module.exports = __webpack_public_path__ + "media/luxury-2026/mianus-garden-living-b8bb4dd2.jpg";